import React from 'react'
import swal from 'sweetalert';
import { Link } from 'react-router-dom';
import { Box, Button, Grid } from '@mui/material';
// import { useOktaAuth } from '@okta/okta-react';
import { useMsal } from "@azure/msal-react";

const PageTabing = ({value}) => {
  
  const { instance } = useMsal();
  const accounts = instance.getAllAccounts();
  //const { authState } = useOktaAuth();
  const isProjectOpen = localStorage.getItem('ProjectEditing');

  const handleClearContent = () => {
    swal({
      title: "Are you sure?",
      text: "You want to clear the contents for the Base Config file?",
      icon: "warning",
      buttons: ["Cancel", "Delete"],
    })
    .then(async willCancel => {
      if (willCancel) {
        const keys = Object.keys(localStorage);
        for(let key in keys){
            if(keys[key] === 'Connections' || keys[key] === 'Parameters' || keys[key] === 'Events' || keys[key] === 'ECURequestPGN' || keys[key] === 'ECUReceiveMessages' || keys[key] === 'ECUConstantTxMessages' || keys[key] === 'HomePage' || keys[key] === 'ECUIDDefinitions' || keys[key] === 'ECUTransmitMessages' || keys[key] === 'Modbus'){
              localStorage.removeItem(keys[key]);
            }
        }
      }
    });
  }

  return (
    <Grid container direction="row" justifyContent="space-between" sx={{pb: { xs: 2 }}}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider',mb:3 }}>
          <Button className={`tabingButton ${value === 'param' ? 'Mui-selected' : ''}`} component={Link} to="/parameters">Parameters</Button>
          <Button className={`tabingButton ${value === 'connection' ? 'Mui-selected' : ''}`} component={Link} to="/connections">Connections</Button>
          <Button className={`tabingButton ${value === 'event' ? 'Mui-selected' : ''}`} component={Link} to="/events">Events</Button>
          <Button className={`tabingButton ${value === 'modbus' ? 'Mui-selected' : ''}`} component={Link} to="/modbus">Modbus</Button>
          <Button className={`tabingButton ${value === 'can' ? 'Mui-selected' : ''}`} component={Link} to="/can/constant-messages">CAN</Button>
          <Button className={`tabingButton ${value === 'st-homepage' ? 'Mui-selected' : ''}`} component={Link} to="/st-homepage">ST Homepage</Button>
      </Box>
      {/* {!isProjectOpen && authState?.accessToken?.claims?.usergroups?.includes("ConfigToolAdmin") && */}
      {!isProjectOpen && accounts[0]?.idTokenClaims?.groups.includes("bc07e057-b44f-40df-ba4f-251acff402e8") &&
        <Box>
            <Button color='primary' onClick={handleClearContent} variant='contained' size='small'> Clear Contents </Button>
        </Box>
      }
    </Grid>
  )
}

export default PageTabing